import { GenericError } from '@/models/generic-error';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { GamesQueryKeys } from '../../queryKeys';
import { fetchGameConfig } from './service';

import { GameIDType } from '@/enums/gameId';
import { GameConfigInputDto } from '@/services/dto/games/game-config-input.dto';
import { GameConfigOutputDto } from '@/services/dto/games/game-config-output.dto';
import { UseGameConfigProps, UseGameConfigQueryKey } from './props';

export function useGameConfig<T extends GameIDType>(
  options?: UseGameConfigProps<T>,
) {
  const { enabled = true, difficultyId, gameId, side } = options ?? {};

  const params: GameConfigInputDto<T> = {
    difficultyId,
    gameId,
    side,
  };
  const queryKey: UseGameConfigQueryKey<T> = [GamesQueryKeys.Config, params];

  const { data, fetchStatus, ...infinityQuery } = useQuery<
    GameConfigOutputDto<T>,
    AxiosError<GenericError>,
    GameConfigOutputDto<T>,
    UseGameConfigQueryKey<T>
  >({
    queryKey,
    queryFn: fetchGameConfig,
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    ...infinityQuery,
    config: data,
    isLoading: infinityQuery.isPending && fetchStatus !== 'idle',
    error: infinityQuery.error as AxiosError<GenericError>,
  };
}
